export default {
    namespaced: true,
    state: {
        loading: false,
        list: [],
        organizerId: null,
    },
    mutations: {
        setLoading: (state, loading = true) => (state.loading = loading),
        setTariffs: (state, tariffs) => (state.list = [...tariffs]),
        setOrganizerId: (state, organizerId) => (state.organizerId = organizerId),
    },
    actions: {
        fetchList: ({ commit }, organizerId) => {
            commit("setOrganizerId", organizerId)
            commit("setLoading")
            const params = {}
            if(organizerId) {
                params.organizerId = organizerId
            }
            return axios
                .get("/tariffs", { params })
                .then(res => commit("setTariffs", res.data.data))
                .catch(err => console.error(err));
        },
        remove: ({ state, commit, dispatch }, id) => {
            return axios
                .delete(`/admin/tariffs/${id}`)
                .then(res => {})
                .finally(res => {
                    dispatch("fetchList", state.organizerId);
                })
                .catch(err => console.error(err));
        },
        create: ({ state, commit, dispatch }, data) => {
            return axios
                .post("/admin/tariffs", data)
                .then(res => {})
                .finally(res => {
                    dispatch("fetchList", state.organizerId);
                })
                .catch(err => console.error(err));
        },
        update: ({ state, commit, dispatch }, { id, data }) => {
            return axios
                .put(`/admin/tariffs/${id}`, data)
                .then(res => {})
                .finally(res => {
                    dispatch("fetchList", state.organizerId);
                })
                .catch(err => console.error(err));
        },
    },
};
